import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { HttpErrorHandlerService } from '../http-error-handler.service';
import { HttpService } from '../http.service';
import {
  StripeConnectAccountState,
  StripeConnectOnboardingLink,
} from '../../types/stripe-connect';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

@Injectable({
  providedIn: 'root',
})
export class StripeConnectApiService {
  constructor(
    private readonly httpService: HttpService,
    private readonly errorHandler: HttpErrorHandlerService,
  ) {}

  status(): Observable<StripeConnectAccountState> {
    return this.httpService.get<ApiResponse<StripeConnectAccountState>>('stripe/connect/status').pipe(
      map((response) => response?.data ?? this.emptyState()),
      catchError((error) => this.errorHandler.handleError(error)),
    );
  }

  refresh(): Observable<StripeConnectAccountState> {
    return this.httpService.post<ApiResponse<StripeConnectAccountState>>('stripe/connect/refresh', {}).pipe(
      map((response) => response?.data ?? this.emptyState()),
      catchError((error) => this.errorHandler.handleError(error)),
    );
  }

  onboard(businessType?: string): Observable<StripeConnectOnboardingLink> {
    const payload = businessType ? { business_type: businessType } : {};
    return this.httpService.post<ApiResponse<StripeConnectOnboardingLink>>('stripe/connect/onboard', payload).pipe(
      map((response) => response?.data ?? { url: '' }),
      catchError((error) => this.errorHandler.handleError(error)),
    );
  }

  private emptyState(): StripeConnectAccountState {
    return {
      status: null,
      charges_enabled: false,
      payouts_enabled: false,
      requirements_due: [],
      onboarded_at: null,
    };
  }
}
